import type { Filter } from '@/app/common/filters/core/filtersTypes.ts';
import { filterTypeOf } from '@/app/common/filters/types/filterTypeBehaviour.ts';

type FiltersResetValuesProps = {
  filters: Filter[];
};
export const filtersResetValues = ({ filters }: FiltersResetValuesProps) =>
  filters.map((filter) => filterTypeOf(filter).resetValue(filter));
